// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".speakerChangeDropDown .ant-dropdown-menu{background-color:rgba(0,0,0,0)}.speakerChangeDropDown ul{display:flex}.speakerChangeDropDown .ant-dropdown-menu-item:hover{background-color:rgba(255,255,255,.3)}", ""]);
// Exports
module.exports = exports;
